import React, { useEffect, useMemo, useRef, useState } from "react";
import "./UserActivityLogsList.scss";
import { Scrollbars } from "react-custom-scrollbars";
import { ReactComponent as UserProfile } from "../../../../assets/svg/profile-user.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/svg/up-arrow.svg";
import moment from "moment-timezone";
import { Dimmer, Loader, Popup } from "semantic-ui-react";
import { ReactComponent as Nodataplaceholder } from "../../../../assets/placeholders/conversation-no-post.svg";
import { useSelector } from "react-redux";
// import { ReactComponent as InfoIcon } from "../../../../assets/svg/info-icon.svg";

const UserActivityLogsList = (props) => {
    const [sortingBy, setSortingBy] = useState(null);
    const [sortingDirection, setSortingDirection] = useState(null);
    const loadingRef = useRef(null);
    const users = useSelector((state) => state.userActivityLogsReducer.companyUsers);
    const companyUsersLoading = useSelector((state) => state.userActivityLogsReducer.companyUsersLoading);

    useEffect(() => {
        const options = {
            threshold: 0.5,
        };
        const observer = new IntersectionObserver((entries) => {
            // console.log("entrrr", entries[0], props.currentPage, props.pages);
            const firstEntry = entries[0];
            if (firstEntry.isIntersecting) {
                if (props.currentPage < props.pages) {
                    // console.log("props.isLoading", props.isLoading);
                    // write logic here to call api and make pagiation
                    if (!props.isLoading) props.handleObserver();
                }
            }
        }, options);

        if (loadingRef.current) {
            observer.observe(loadingRef.current);
        }

        return () => {
            if (loadingRef.current) {
                observer.unobserve(loadingRef.current);
            }
        };
    }, [props.currentPage, props.pages, props.isLoading]);

    const getActivityLogsList = () => {
        let loginlogsList = props.userActivityLogsList ? props.userActivityLogsList.slice(0) : [];

        // console.log("loginlogsList", loginlogsList, props.userActivityLogsList);
        // searching
        let searchtext = props.searchText.trim();
        if (searchtext !== "") {
            let blocks = [];

            props.userActivityLogsList?.forEach((p) => {
                const user = users[p.lite_id];

                if (
                    // (user?.name && user.name?.toLowerCase().indexOf(searchtext.toLowerCase()) > -1) ||
                    (user?.name && user.name?.toLowerCase().includes(searchtext.toLowerCase())) ||
                    (p.date && moment(p.date).format("YYYY-MM-DD").indexOf(searchtext) > -1) ||
                    p.module?.toLowerCase().includes(searchtext.toLowerCase()) ||
                    p.content?.toLowerCase().includes(searchtext.toLowerCase())
                )
                    blocks.push(p);
            });
            loginlogsList = blocks;
        }

        if (props.resultsLength !== loginlogsList.length) props.setResultsLength(loginlogsList.length); // must fix this
        if (sortingBy) {
            let order = sortingDirection === "asc" ? 1 : -1;

            if (sortingBy === "username") {
                loginlogsList.sort((a, b) => {
                    return order * a.name.localeCompare(b.name);
                });
            } else if (sortingBy === "date_time") {
                loginlogsList.sort((a, b) => order * (moment(a.date) - moment(b.date)));
            }
        }
        return loginlogsList;
    };

    const sortingChange = (type) => {
        if (sortingBy === type) {
            if (sortingDirection === "asc") {
                setSortingDirection("dec");
            } else {
                setSortingDirection(null);
                setSortingBy(null);
            }
        } else {
            setSortingBy(type);
            setSortingDirection("asc");
        }
    };

    const fullName = (name) => {
        return <div className="full-name">{name.join("")}</div>;
    };

    const truncatedName = (text) => {
        let name = text;
        if (name.length > 30) {
            name = name.join("").substring(0, 30 - 3) + "...";
            return <Popup inverted trigger={<span className="full-name-popup">{name}</span>} content={() => fullName(text)} position="bottom center" />;
        } else {
            return text.join("");
        }
    };

    const userActivityLogsList = useMemo(() => getActivityLogsList(), [sortingBy, sortingDirection, props.userActivityLogsList, props.searchText]);

    return (
        <>
            <div className="user-activity-logs-list">
                <div className="loginlogsList-table">
                    <div className="loginlogsList-table-row header">
                        {/* <div className="loginlogsList-table-cell loginlogsList-name">
                            User
                            <span
                                onClick={() => sortingChange("username")}
                                title="Sort"
                                className={`sorting-arrow ${
                                    sortingBy === "username" ? (sortingDirection === "dec" ? "arrow-persistent arrow-downwards" : "arrow-persistent") : ""
                                } `}>
                                {<ArrowIcon />}
                            </span>
                        </div> */}

                        <div className="loginlogsList-table-cell loginlogsList-name">User</div>

                        <div className="loginlogsList-table-cell loginlogsList-creation-date">
                            <Popup
                                content=" The below time will be in your profile timezone. The format will be YYYY-MM-DD HH:mm:ss "
                                trigger={
                                    <span>
                                        Date
                                        {/* <span className="date__format">{`(${moment.utc().tz(props.userTimeZone).format("z")})`}</span> */}
                                        <span
                                            onClick={() => sortingChange("date_time")}
                                            title="Sort"
                                            className={`sorting-arrow ${
                                                sortingBy === "date_time"
                                                    ? sortingDirection === "dec"
                                                        ? "arrow-persistent arrow-downwards"
                                                        : "arrow-persistent"
                                                    : ""
                                            } `}>
                                            {<ArrowIcon />}
                                        </span>
                                    </span>
                                }
                                size="mini"
                                position="right center"
                                inverted
                            />
                        </div>
                        <div className="loginlogsList-table-cell loginlogsList-module-name">Module</div>
                        <div className="loginlogsList-table-cell loginlogsList-email">
                            Activity
                            {/* <span
                                onClick={() => sortingChange("email")}
                                title="Sort"
                                className={`sorting-arrow ${
                                    sortingBy === "email"
                                        ? sortingDirection === "dec"
                                            ? "arrow-persistent arrow-downwards"
                                            : "arrow-persistent"
                                        : ""
                                } `}>
                                {<ArrowIcon />}
                            </span> */}
                        </div>
                        {/* <div className="loginlogsList-table-cell loginlogsList-priority"> Priority</div> */}
                    </div>

                    <Scrollbars
                        // ref={(scrollRef) => (this.scrollRef = scrollRef)}
                        autoHide
                        className="loginlogsList-table-body">
                        {userActivityLogsList && userActivityLogsList.length > 0 ? (
                            userActivityLogsList.map((d) => {
                                const user = users[d.lite_id];
                                return (
                                    <div className="loginlogsList-table-row" key={1}>
                                        <div className="loginlogsList-table-cell loginlogsList-name">
                                            {user?.image && user?.image?.indexOf("https") !== -1 ? <img src={user?.image} /> : <UserProfile />}
                                            {/* <span>{truncatedName(user?.name?.split("") || "User")}</span> */}
                                            <span>{user?.name || "User"}</span>
                                        </div>

                                        <div className="loginlogsList-table-cell loginlogsList-creation-date">
                                            {/* <Popup
                                                trigger={<span>{moment(d.date).utc().tz(props.userTimeZone).format("YYYY-MM-DD")}</span>}
                                                content={moment(d.date).utc().tz(props.userTimeZone).format("YYYY-MM-DD HH:mm:ss z")}
                                                size="mini"
                                                position="right center"
                                                inverted
                                            /> */}
                                            <span>{moment.utc(d.date).tz(props.userTimeZone).format("YYYY-MM-DD HH:mm:ss")}</span>
                                        </div>
                                        <div className="loginlogsList-table-cell loginlogsList-module-name">{<span>{d.module}</span>}</div>
                                        <div className="loginlogsList-table-cell loginlogsList-email">{<span>{d.content}</span>}</div>
                                        {/* <div className="loginlogsList-table-cell loginlogsList-priority">{<span>{d.priority}</span>}</div> */}
                                    </div>
                                );
                            })
                        ) : !props.isLoading && userActivityLogsList && userActivityLogsList.length === 0 ? (
                            <div className="no-data">
                                {/* <p>No Data</p> */}
                                <Nodataplaceholder />
                                <p>{props.searchText.trim() !== "" ? `Sorry we couldn't find any result related to your search query` : `No data found`}</p>
                            </div>
                        ) : null}
                        <div
                            className="list-loading"
                            style={{
                                display:
                                    (!props.isLoading && userActivityLogsList && userActivityLogsList.length === 0) || props.currentPage >= props.pages
                                        ? "none"
                                        : "block",
                            }}>
                            {userActivityLogsList.length > 0 ? (
                                <div
                                    // ref={(loadingRef) => (this.loadingRef = loadingRef)}
                                    ref={loadingRef}
                                    className="list-loading-intersection"></div>
                            ) : null}
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        {(props.isLoading && props.userActivityLogsList.length === 0) || companyUsersLoading ? (
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        ) : // ) : !props.isLoading && userActivityLogsList && userActivityLogsList.length === 0 ? (
                        //     <div className="no-data">
                        //         {/* <p>No Data</p> */}
                        //         <Nodataplaceholder />
                        //         <p>{props.searchText.trim() !== "" ? `Sorry we couldn't find any result related to your search query` : `No data found`}</p>
                        //     </div>
                        null}
                    </Scrollbars>
                </div>
            </div>
        </>
    );
};

export default UserActivityLogsList;
